export enum SettingTypesConsts {
  COMMENT = 'COMMENT',
  FIXED = 'FIXED',
  CALCULATED = 'CALCULATED',
}
